import { ChangeEvent } from 'react'
import { TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { useStyles } from './styles'
import { ETranslationNs } from 'src/types'

interface ISocialInputProps {
  inputIcon?: JSX.Element
  inputPlaceholder?: string
  inputName: string
  error?: string
  value?: string
  handleChange?: (e: ChangeEvent<HTMLInputElement>) => void
}

const SocialInput = ({
  inputIcon,
  inputPlaceholder,
  inputName,
  error,
  value,
  handleChange,
}: ISocialInputProps) => {
  const [t] = useTranslation(ETranslationNs.Form)
  const classes = useStyles()

  return (
    <>
      <TextField
        autoComplete="off"
        variant="standard"
        className={classes.container}
        InputProps={{
          disableUnderline: true,
          startAdornment: <div className={classes.iconWrapper}>{inputIcon}</div>,
        }}
        inputProps={{
          className: classes.input,
        }}
        onChange={handleChange}
        focused
        size="small"
        value={value ?? ''}
        id={inputName}
        name={inputName}
        fullWidth
        placeholder={`${t('text-input-placeholder-prepend.v')} ${inputPlaceholder}`}
        type="text"
        error={!!error}
        helperText={error}
      />
      {/* {isTablet && isEditable && (
          <IconButton sx={{ p: 0 }} onClick={handleEditButton}>
            <EditIcon />
          </IconButton>
        )} */}
    </>
  )
}

export { SocialInput }
